import React, { Component } from 'react';
import cx from 'classnames';
import { noop } from 'lodash';
import PropTypes from 'prop-types';

export default class Token extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return this.props.onRemove && !this.props.disabled ? this.renderRemovableToken() : this.renderReadOnlyToken();
    }

    renderRemovableToken() {
        const { children, className, onRemove, selected, ...otherProps } = this.props;
        return (
            <div
                {...otherProps}
                className={cx('token', 'token-removeable', {}, className)} //'token-selected': selected,}, className)}
                tabIndex={0}
            >
                {children}
                <span className="close-button" onClick={onRemove} role="button">
                    &times;
                </span>
            </div>
        );
    }

    renderReadOnlyToken() {
        const { children, className, disabled, href } = this.props;
        const classnames = cx('token', { 'token-disabled': disabled }, className);

        return <div className={classnames}>{children}</div>;
    }
}

// Token.propTypes = {
//   onRemove: PropTypes.func,
//   selected: PropTypes.bool,
// };

// Token.defaultProps = {
//   onRemove: noop,
//   selected: false,
// };



// WEBPACK FOOTER //
// ./src/shared/token.js